import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  ref: "pixelartShow"
};
const _hoisted_2 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_pixelartShow = _resolveComponent("pixelartShow");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_particleList = _resolveComponent("particleList");
  return _withDirectives((_openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_pixelartShow, {
    previewImg: $props.currentEffectimg,
    currentimgInfo: $props.currentimgInfo,
    onOnClicklike: $options.onClicklike
  }, null, 8, ["previewImg", "currentimgInfo", "onOnClicklike"])], 512), $options.hasOnBuildDetail ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_row, {
    gutter: 40,
    justify: "space-around"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        onClick: $options.onHandleBuild,
        class: "dialog-button"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode(" Build It ")])),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        onClick: $options.onGetPDF,
        class: "dialog-button"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" Get PDF ")])),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  })])) : _createCommentVNode("", true), _createVNode(_component_particleList, _mergeProps(_ctx.$attrs, {
    particleImg: $props.currentimgInfo.particleImg,
    particelList: $props.currentimgInfo.color_numbers
  }), null, 16, ["particleImg", "particelList"])], 512)), [[_vShow, $props.show]]);
}